import { ArrowRightIcon, CheckIcon, XMarkIcon } from "@heroicons/react/24/outline"
import { Button } from "../Control/Button/Button"
import { ColumnLabel } from "../Layout/ColumnLabel"

export type BooleanSelectorProps = {
    label: string,
    value: boolean,
    update: (values: boolean) => void
}

export function BooleanSelector(props: BooleanSelectorProps) {
    return (
        <ColumnLabel label={props.label} classNames={{ column2: "flex content-start flex-wrap" }}>
            <Button
                className="flex-1 flex items-center justify-center min-h-[34px]"
                color={props.value ? "emphasis" : "component"}
                onClick={() => props.update(!props.value)}
            >
                <span>{ props.value ? "on" : "off" }</span>
            </Button>
        </ColumnLabel>
    )
}